// Put constants that don't fit into a category in this file

export const COPYRIGHT_MESSAGE = "© 2023 PMG Intelligence. All rights Reserved";

export const TABLE_QUESTION_ROWS_PER_PAGE = 6;

export const MULTI_SELECT_INPUT_TYPES = Object.freeze({
    checkbox: "checkbox",
    radio: "radio",
});
